import React from 'react'

function StatusPill2(props) {
const status = props.status;
  return (
    <div style={{
        maxHeight:"30px"
    }}>
        <div className='center' style={{
            borderRadius:"20px",
            padding:'6px 10px',
            fontSize:"12px",
            background:`${
                status 
                ?"#DCFCE7"
                :"#FEE2E2"
            }`,
            color:`${ status
                ?"#14532D"
                :"#7F1D1D"
        }`
        }}>
            {status?"Resolved":"Unresolved"}
        </div>
    </div>
  )
}

export default StatusPill2